function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wky7o7rhna"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4466",
    transform: "translate(39 317)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 17862",
    transform: "translate(-39 -317)",
    style: {
      clipPath: "url(#wky7o7rhna)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25436",
    d: "M13.85 21.939H7.515A1.553 1.553 0 0 1 6 20.425V5.734a1.574 1.574 0 0 1 .391-1.06q.392-.454.669-.454h5.1a2.531 2.531 0 0 1 4.077-1.451 2.437 2.437 0 0 1 .871 1.451h5.1a1.553 1.553 0 0 1 1.512 1.514v5.124h-1.514V5.734H19.53v3.281h-9.34V5.734H7.515v14.691h6.335zm4.771-.631-4.039-4.038 1.085-1.085 2.953 2.953 6.034-6.038 1.085 1.085zM15.087 5.633a.992.992 0 0 0 1.01-1.01 1.01 1.01 0 1 0-2.019 0 .992.992 0 0 0 1.01 1.01z",
    transform: "translate(35.63 317.431)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.c079d11b248852018ffc7c7e5308ae3b.svg";
export { ForwardRef as ReactComponent };